import React from 'react'

import useActiveLoyalty from './hooks/useActiveLoyalty'
import Loyalty from './loyalties/getLoyaltyProgram'
import {LOYALTIES} from './loyalties/loyaltiesEnum'

export default function LoyaltyProgram(props) {
  const {website} = props
  const {activeLoyalty} = useActiveLoyalty(website?._id)

  if (!activeLoyalty || !Object.values(LOYALTIES).includes(activeLoyalty.name)) return null

  return <Loyalty loyaltyType={activeLoyalty.name} activeLoyalty={activeLoyalty} {...props} />
}
